<template>
  <!-- product page -->
  <div ref="wrapper" class="scroll-view" v-scroll-bottom="loadMoreData">
  <div class="content">
  <div class="product-page">
    <div class="product-wrap">
        <div class="search-widget">
            <!-- 转链btn -->
            <div class="link-btn-wrap" v-if="loginType === 'up'">
                <div class="link-btn" @click="handleLinkPage">
                    <hkj-svg iconName="icon-tiaozhuanlianjie1"></hkj-svg>
                    <!-- <img src="../assets/images/icon/link-white.png" mode=""/> -->
                    <span>转链</span>
                </div>
            </div>
            <div class="search-wrap">
                <i class="search-icon" type="search" size="25"></i>
                <span type="search" @click="handleToSearchPage" class="search-input" placeholder="请输入商品名称/商品ID" >请输入商品名称</span>
            </div>
        </div>
        <div class="category-wrap">
            <CategoryWidget :current="currentCategory" :list="categoryList" @onCategory="handleCategory"></CategoryWidget>
        </div>
        <div class="op-wrap">
          <div class="op">
            <hkj-svg v-if="isGrid" class="liebiao" iconName="icon-liebiao" @clickIcon="handleChangeLayout"></hkj-svg>
            <hkj-svg v-if="!isGrid" iconName="icon-gezi" @clickIcon="handleChangeLayout"></hkj-svg>
            <!-- <span class="op-block" v-if="isGrid" @click="handleChangeLayout()">一列</span> -->
            <!-- <span class="op-block" v-if="!isGrid" @click="handleChangeLayout()">两列</span> -->
          </div>
        </div>
        <div class="product-list-wrap">
            <good-list :is-rank="isRank" :is-grid="isGrid" :product-list="productList" :has-more="hasMore"></good-list>
        </div>
    </div>
    <!-- <div v-if="productList.length>0" ref="loadreserve" id="reserve" style="height: 20px;"></div> -->
    <!-- <Toast type="loading" v-if="showToast">加载数据中...</Toast> -->
  </div>
  </div>
  </div>
</template>
<script>
// import utils from '@/utils/utils';
import CategoryWidget from '@/components/category/CategoryWidget.vue';
import GoodList from '@/components/list/GoodList.vue'
import {getCategoryList} from '@/services/product'
// import Toast from 'vue-weui/components/toast/toast.vue'
import productHelper from '@/helpers/productHelper'
import HkjSvg from '@/components/svg/index.vue'
import { loginStore } from '@/store';

export default {
  components: {
    CategoryWidget,
    GoodList,
    // Toast,
    HkjSvg,
  },
  data() {
    return {
      categoryList: [{
        cidName: '全部',
        cid: '-1'
      }],
      currentCategory: {},
      isGrid: false,
      productList: [],
      hasMore: false,
      showToast: false,
      page: 1,
      keyword: '',
      scroll: {},
      observe: null,
      rankBy: '',
      isRank: false,
      loginType: ''
    }
  },
  created() {
    getCategoryList({}).then(res => {
      res.data.forEach(it => {
        this.categoryList.push(it)
      })
      this.currentCategory = this.categoryList[0]
      this.handleCategory(this.currentCategory)
    })
    this.loginType = loginStore.getLoginType()
  },
  mounted() {
  },
  beforeDestroy(){
    if(this.observe) {
      this.observe.disconnect()
    }
  },
  methods: {
    handleLinkPage() {
      this.$router.push('/coupon/custom')
    },
    handleToSearchPage() {
      this.$router.push('/search')
    },
    handleCategory(cur) {
      this.productList = []
      this.page = 1
      this.currentCategory = cur
      
      productHelper.getProductList(this)
    },
    loadMoreData() {
      this.page++
      productHelper.getProductList(this)
    },
    handleChangeLayout() {
      this.page = 1
      this.productList = []
      this.isGrid = !this.isGrid
      this.isRank = !this.isRank
      this.rankBy = this.isGrid ? '' : ''
      productHelper.getProductList(this)
    }
  }
}
</script>
<style scoped>
/* pages product */
.product-page {
  /* background-color: rgba(0, 0, 0, 0.05); */
  /* min-height: 56.25rem; */
  box-sizing: border-box;
}

.product-wrap {
  padding-top: var(--len20);
}

.search-widget {
  display: flex;
  padding: 0 var(--len10);
  margin-bottom: var(--len10);
}


.search-wrap {
    position: relative;
    flex: 1;
}

.search-input {
    width: 100%;
    height: var(--len30);
    background-color: white;
    /* border-radius: 5px; */
    border-radius: var(--len30);
    /* border-bottom-left-radius: none; */
    border: 0.5px solid var(--primary-color);
    font-size: 0.75rem;
    box-sizing: border-box;
    padding-left: 2.1875rem;
    color: gray;
    display: inline-block;
    line-height: var(--len30);
}

.search-icon {
    position: absolute;
    top: 3px;
    left: var(--len10);
    color: lightgray;
}
.link-btn-wrap{
    display: flex;
    align-items: center;
}
.link-btn{
    width: var(--len80);
    height: 1.5625rem;
    border: 1px solid rgba(0, 0, 0, 0.01);
    box-sizing: border-box;
    border-radius: var(--len30);
    border-bottom-left-radius: 0;
    background-color: var(--primary-color);
    color: white;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    line-height: 1.5625rem;
    margin-right: var(--len10);
}
.link-btn img{
    width: var(--len15);
    height: var(--len15);
    margin-left: var(--len10);
    margin-right: var(--len5);
}
.product-list-wrap {
    padding: 0 var(--len10);
}
.op-wrap{
  position: absolute;
  top: var(--len10);
  right: var(--len10);
  /* padding: var(--len10) var(--len10) 0 var(--len10); */
}
/* 扫码界面样式 */
.ku-scanner {
  height: 100vh;
  background: #000;
}
.ku-scanner-content {
    position: relative;
    height: 100%;
}
.ku-scanner-tooltip {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  color: #fff;
  text-align: center;
  font-size: 14px;
}

.ku-scanner-section {
  width: 280px;
  height: 280px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid rgba(25, 137, 250, 0.2);
  overflow: hidden;
}
/* 扫描框四角 */
  .ku-scanner-section:before,
  .ku-scanner-section:after,
  .ku-scanner-section-angle:before,
  .ku-scanner-section-angle:after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    border: 2px solid #1989fa;
  }

  .ku-scanner-section:before {
    top: -2px;
    left: -2px;
    border-bottom: none;
    border-right: none;
  }

  .ku-scanner-section:after {
    top: -2px;
    right: -2px;
    border-bottom: none;
    border-left: none;
  }
.ku-scanner-section-angle:before {
    bottom: -2px;
    left: -2px;
    border-top: none;
    border-right: none;
  }

  .ku-scanner-section-angle:after {
    bottom: -2px;
    right: -2px;
    border-top: none;
    border-left: none;
  }

  /* 扫描动画线 */
  .ku-scanner-section-animation-line {
    position: absolute;
    height: 1px;
    width: 100%;
    background: #1989fa;
    top: 50%;
    animation: scan-line 2s infinite;
  }
 
/* 扫描动画 */
@keyframes scan-line {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(100%);
  }
}
</style>